<template>
  <div class="liu pos-manage">
    <mt-header fixed title="加机" class="title2">
      <mt-button slot="left" icon="back" @click="onBackBtnClick">返回</mt-button>
    </mt-header>
    <div class="scroll-container" :style="customScrollHeight">
      <div class="form mt-15">
        <!-- 设备编号 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ posData.equipmentNumber.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="posData.equipmentNumber.value" :placeholder="posData.equipmentNumber.placeholder">
              <div class="scan" @click="onEquipmentNumberScanClick">
                <svg-icon :icon-class="svgName" class-name="cur-icon"></svg-icon>
              </div>
            </div>
          </div>
        </div>
        <!-- 门店名称 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ posData.equipmentRemarks.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="posData.equipmentRemarks.value" :placeholder="posData.equipmentRemarks.placeholder">
            </div>
          </div>
        </div>
        <!-- 装机地址 -->
        <div class="row">
          <div class="item">
            <div class="label">
              <span>{{ posData.equipmentAddress.label }}</span>
            </div>
            <div class="content">
              <input type="text" v-model="posData.equipmentAddress.value" :placeholder="posData.equipmentAddress.placeholder">
            </div>
          </div>
        </div>

      </div>
      <div class="btn">
        <mt-button type="primary" size="large" @click="onPosBindSubmitClick">
          保存
        </mt-button>
      </div>
    </div>
  </div>
</template>

<script>
/*global  PUBLIC_CXZFZS_TAGUUID*/

import SvgIcon from '@/components/SvgIcon';
import { AddPayTagExt } from '@/api/customer';
import { validateEmpty } from '@/utils/validate';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { CusToast, CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'H5PosManageBind',
  comments: { SvgIcon },
  data() {
    return {
      svgName: 'scan',
      posData: {
        equipmentNumber: { label: '设备编号', value: '', placeholder: '请扫描码牌上的二维码' },
        equipmentRemarks: { label: '门店名称', value: '', placeholder: '请输入门店名称' },
        equipmentAddress: { label: '装机地址', value: '', placeholder: '请输入装机地址' },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.posData.equipmentNumber.value = PUBLIC_CXZFZS_TAGUUID || '';
      this.posData.equipmentRemarks.value = this.$route.query.companyName;
    });
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
  },
  methods: {
    // 通过接口调用加机接口
    addPayTagExt() {
      CusLoadingOpen();
      const data = {
        userId: this.$route.query.id,
        address: this.posData.equipmentAddress.value,
        jyUUID: this.posData.equipmentNumber.value,
        payTagName: this.posData.equipmentRemarks.value,
      };
      AddPayTagExt(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              CusAlert('加机成功', () => {
                this.$router.go(-2);
              });
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 验证当前页面数据的合法性
    validatePageData(callback = null) {
      const equipmentNumberErr = validateEmpty(this.posData.equipmentNumber.value);
      const equipmentAddressErr = validateEmpty(this.posData.equipmentAddress.value);
      const equipmentRemarksErr = validateEmpty(this.posData.equipmentRemarks.value);
      if (!equipmentNumberErr && !equipmentAddressErr && !equipmentRemarksErr) {
        callback && callback();
      } else {
        if (equipmentNumberErr) {
          CusToast('设备编号不能为空');
          return;
        }
        if (equipmentRemarksErr) {
          CusToast('门店名称不能为空');
          return;
        }
        if (equipmentAddressErr) {
          CusToast('装机地址不能为空');
          return;
        }
      }
    },
    // 返回事件
    onBackBtnClick() {
      this.$router.go(-2);
    },
    // 加机拍照按钮
    onEquipmentNumberScanClick() {
      if (!PUBLIC_CXZFZS_TAGUUID) {
        window.location.replace('addpos://qrcode');
      } else {
        CusToast('第二次调用扫描设备失败，想再次扫描二维码请返回上级页面后重新进入', 5000);
      }
    },
    // 加机提交按钮单击事件
    onPosBindSubmitClick() {
      this.validatePageData(() => {
        this.addPayTagExt();
      });
    },
  },
};
</script>
